const missionStatus = {
  incomplete: "incomplete",
  inProgress: "inProgress",
  completed: "completed",
};

module.exports = missionStatus;
